<div class="card mb-3" id="panel-list-{{id}}">
  <div class="card-header card-panel" [ngClass]="{'opened': opened, 'd-flex justify-content-between': titleFirts}" (click)="opened = !opened">
      <span *ngIf="titleFirts" style="font-weight: 600;">{{title}}</span>
      <i class="fa fa-caret-right" *ngIf="!opened"></i>
      <i class="fa fa-caret-down" *ngIf="opened"></i> <span *ngIf="!titleFirts"> {{title}}</span>

  </div>
  <div class="card-body" [ngClass]="{'closed': !opened}">
    <ng-content></ng-content>
  </div>
</div>
